import { FormEvent, useState } from 'react';
import type { CurrentMember } from '../../shared/models';
import { api } from '../api';
import { LocaleSelect, useI18n } from '../i18n';
import { localizedError } from '../i18n/errors';

export function LoginPage({ onLogin }: { onLogin: (member: CurrentMember) => void }) {
  const { locale, t } = useI18n();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault(); setBusy(true); setError('');
    try {
      const result = await api.login(email, password);
      onLogin(result.member);
    } catch (err) {
      setError(localizedError(err, locale, { 'zh-CN': '登录失败', en: 'Sign-in failed' }));
    } finally { setBusy(false); }
  }

  return <main className="auth-layout">
    <section className="auth-intro">
      <div className="auth-locale"><LocaleSelect /></div>
      <span className="eyebrow">Menu Lab</span>
      <h1>{t('auth.title')}</h1>
      <p>{t('auth.subtitle')}</p>
    </section>
    <form className="auth-card" onSubmit={submit}>
      <label>{t('auth.email')}<input type="email" value={email} onChange={e => setEmail(e.target.value)} autoComplete="email" required /></label>
      <label>{t('auth.password')}<input type="password" value={password} onChange={e => setPassword(e.target.value)} autoComplete="current-password" required /></label>
      <small>{t('auth.forgot')}</small>
      {error && <p className="form-error">{error}</p>}
      <button className="primary-button" disabled={busy}>{busy ? t('auth.loggingIn') : t('auth.login')}</button>
    </form>
  </main>;
}
